<script lang="ts" setup>
import { ref, watch } from 'vue';
import { useRouter } from 'vue-router';
import storeAuth from '@store/auth';
import { User } from '../../types/user.type';
import { useI18n } from 'vue-i18n';

const { t } = useI18n();
const router = useRouter();

const store = storeAuth();
const filterMenu = ref();

const menu: any = [
  {
    title: t('ajustes.ajustes.agentes'),
    icon: '/icons/ajustes.svg',
    name: 'Agentes',
  },
  {
    title: t('ajustes.ajustes.assets'),
    icon: '/icons/ajustes.svg',
    name: 'Assets',
  },
  {
    title: t('ajustes.ajustes.companias'),
    icon: '/icons/ajustes.svg',
    name: 'Companias',
  },
  {
    title: t('ajustes.ajustes.configuracion_certificados'),
    icon: '/icons/ajustes.svg',
    name: 'Configuracion de Certificados',
  },
  {
    title: t('ajustes.ajustes.companias_gps'),
    icon: '/icons/ajustes.svg',
    name: 'CompaniasGps',
  },
  {
    title: t('ajustes.ajustes.contenedores'),
    icon: '/icons/ajustes.svg',
    name: 'Contenedores',
  },
  {
    title: t('ajustes.ajustes.excepciones_ofac'),
    icon: '/icons/ajustes.svg',
    name: 'Excepciones Ofac',
  },
  {
    title: t('ajustes.ajustes.idiomas'),
    icon: '/icons/ajustes.svg',
    name: 'Idiomas',
  },
  {
    title: t('ajustes.ajustes.medidas_de_seguridad'),
    icon: '/icons/ajustes.svg',
    name: 'Medidas de seguridad',
  },
  {
    title: t('ajustes.ajustes.paises'),
    icon: '/icons/ajustes.svg',
    name: 'Paises',
  },
  {
    title: t('ajustes.ajustes.plantillas'),
    icon: '/icons/ajustes.svg',
    name: 'Plantillas',
  },
  {
    title: t('ajustes.ajustes.productos'),
    icon: '/icons/ajustes.svg',
    name: 'Productos',
  },

  {
    title: t('ajustes.ajustes.roles'),
    icon: '/icons/ajustes.svg',
    name: 'Roles',
  },
  {
    title: t('ajustes.ajustes.sub_assets'),
    icon: '/icons/ajustes.svg',
    name: 'SubAssets',
  },
  {
    title: t('ajustes.ajustes.taxes'),
    icon: '/icons/ajustes.svg',
    name: 'Taxes',
  },
  {
    title: t('ajustes.ajustes.usuarios'),
    icon: '/icons/ajustes.svg',
    name: 'Usuarios',
  },
  {
    title: t('ajustes.ajustes.reaseguradores'),
    icon: '/icons/ajustes.svg',
    name: 'Reaseguradores',
  },
  {
    title: t('ajustes.ajustes.clientes'),
    icon: '/icons/ajustes.svg',
    name: 'Clientes',
  },
  {
    title: t('ajustes.ajustes.tipos_de_assets'),
    icon: '/icons/ajustes.svg',
    name: 'TypeAssets',
  },
  {
    title: t('ajustes.ajustes.tipos_de_transporte'),
    icon: '/icons/ajustes.svg',
    name: 'Tipos de transporte',
  },
  {
    title: t('ajustes.ajustes.corredores'),
    icon: '/icons/ajustes.svg',
    name: 'Corredores',
  },
].sort((a, b) =>
  a.name.localeCompare(b.name, 'es', { sensitivity: 'base' })
);

watch(
  () => store.user as User,
  (newUser: User) => {
    const userPermissions = newUser?.permission;

    if (!userPermissions) return;

    filterMenu.value = menu.filter((item: any) => {
		if (item.name === 'Companias') {
			return userPermissions.includes('Companias ABM');
		}
		if (item.name === 'Tipos de transporte') {
			return userPermissions.includes('Tipos de transporte');
		}
		return userPermissions.includes(item.name);
	});
  },
  {
    immediate: true,
  },
);

const handlerIsOpen = ref<boolean>(false);

const handleRedirect = (e: any) => {
  router.push({ name: e.name });
};
</script>
<template>
  <div
    :class="'d-flex flex-row'"
    :style="{
      padding: handlerIsOpen ? '0px 16rem 0px 0px' : '0px 3rem 0px 0px',
    }"
  >
    <router-view></router-view>
    <ActionBar
      :menu="filterMenu"
      :iconOpen="'/icons/flecha_left_primary.svg'"
      :iconClose="'/icons/flecha_right_primary.svg'"
      :colorTitle="'color-secondary'"
      :backgroundItem="'#ff436f'"
      :title="t('global.ajustes_disponibles')"
      @isOpen="handlerIsOpen = !handlerIsOpen"
      @navigate="handleRedirect"
    />
  </div>
</template>
